import { Card } from '@nextui-org/react';

import Bismillah from '../components/Bismillah';
import CardPageContainer from '../components/CardPageContainer';
import Footer from '../components/Footer';
import Header from '../components/Header';
import InnerCardPageContainer from '../components/InnerCardPageContainer';
import Layout from '../components/Layout';

export default function Privacy() {
  const policyDate = 'February 5, 2023';
  const updatedDate = 'May 9, 2023';

  return (
    <Layout>
      <Header description="Privacy Policy for Thaqalayn.net" title="Privacy Policy" />
      <CardPageContainer>
        <InnerCardPageContainer>
          <Card className="single-card" role="article">
            <div className="card-body mt-2 mb-2">
              <Bismillah />
              <h1 className="text-xl font-bold">Privacy Policy</h1>
              Effective Date: <span className="italic">February 5, 2023</span> <br />
              Last Updated: <span className="italic">May 9, 2023</span>
              <br />
              <br />
              <strong>Introduction:</strong>
              Thaqalayn.net is committed to protecting the privacy of its users and visitors. This Privacy Policy
              explains how we collect, use, and disclose information through our website.
              <br />
              <br />
              <strong>Information Collection:</strong>
              We collect your email address when you choose to provide it to us for the purpose of being notified when a
              text you reported has been corrected. Apart from this, we do not collect any personal information from our
              users and visitors. We only use Google Analytics to track general website usage and performance, which
              does not collect personal data.
              <br />
              <br />
              <strong>Data Processing:</strong>
              We process your email address solely for the purpose of sending notifications regarding corrected texts
              you have reported. As we do not collect any other personal data, no additional data processing takes
              place.
              <br />
              <br />
              <strong>Data Retention:</strong>
              We retain your email address only for as long as necessary to provide you with the notification service.
              If you wish to have your email address removed from our records, you can request deletion by sending an
              email to <a href="mailto:info@thaqalayn.net">info@thaqalayn.net</a>.
              <br />
              <br />
              <strong>Disclosure of Information:</strong>
              We do not disclose your email address or any other personal information to any third parties. The
              information collected through Google Analytics is used solely for website usage analysis and performance
              tracking.
              <br />
              <br />
              <strong>Your Rights:</strong>
              As a resident of the European Union, you have the right to access, correct, and delete any personal
              information that we may collect about you. Since we only collect email addresses for the notification
              service, these rights apply to the extent of the email addresses we collect.
              <br />
              <br />
              <strong>Changes to This Privacy Policy:</strong>
              We may update this Privacy Policy from time to time. If we make any material changes to this policy, we
              will post the updated policy on our website and update the effective date above.
              <br />
              <br />
              <strong>Contact Us:</strong>
              If you have any questions or concerns about this Privacy Policy, please contact us at{' '}
              <a href="mailto:info@thaqalayn.net">info@thaqalayn.net</a>.
              <br />
              <br />
              By using our website, you acknowledge that you have read and understand this Privacy Policy.
            </div>
          </Card>
          <div className="mt-10" />
        </InnerCardPageContainer>
        <Footer />
      </CardPageContainer>
    </Layout>
  );
}
